import { statsThemes } from './themes'
import { StatsTheme, StatsThemeId } from './types'

export const getStatsTheme = (id: StatsThemeId): StatsTheme => {
  return statsThemes[id]
}

export const getEnabledStatsThemes = (
  enabledThemes: StatsThemeId[]
): StatsTheme[] => {
  const themes = []

  for (const id of enabledThemes) {
    themes.push(getStatsTheme(id))
  }

  return themes
}
